export const TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refreshToken";
